export default "__VITE_ASSET__CmCoqLVN__"